import { Link } from 'react-router-dom';
import { useDarkHero } from '@/contexts/NavbarContext';

const features = [
  { icon: 'ri-file-text-line', title: 'Elektronik Beyanname (ETGB)', desc: '300 kg ve 15.000 € fatura değerini aşmayan gönderileriniz ETGB kapsamında hiçbir prosedür gerektirmeden gerçekleştirilir.' },
  { icon: 'ri-money-dollar-circle-line', title: 'KDV İadesi', desc: 'Firmanız adına yaptığınız satışların gönderimini ETGB kapsamında yapmanız durumunda KDV iadenizi kolayca alabilirsiniz.' },
  { icon: 'ri-speed-line', title: 'Hızlı Gümrükleme', desc: 'Alıcıya hiçbir prosedür gerektirmeden, hızlı gümrükleme sistemi ile teslim edilir.' },
  { icon: 'ri-building-line', title: 'İhracatçı Birliği Kaydı', desc: 'Mikro ihracat kapsamında firmanız adına ilk defa gönderi yapıyorsanız öncesinde tek sefere mahsus olarak ihracatçılar birliğine kaydolmanız gerekir.' },
  { icon: 'ri-global-line', title: 'Uluslararası Teslimat', desc: 'Gönderileriniz dünyanın her noktasına güvenle ve hızla ulaştırılır.' },
  { icon: 'ri-customer-service-2-line', title: 'Uzman Destek', desc: 'Mikro ihracat süreçlerinde uzman ekibimiz her adımda yanınızda.' },
];

export default function MikroIhracatPage() {
  useDarkHero(true);
  return (
    <main className="min-h-screen" style={{ background: 'var(--bg)' }}>
      {/* Hero */}
      <section className="relative min-h-[680px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=customs%20officer%20checking%20export%20documents%20at%20international%20border%2C%20official%20stamps%20and%20paperwork%2C%20professional%20trade%20compliance%20environment%2C%20dark%20moody%20office%20lighting%20with%20orange%20accent%2C%20global%20trade%20concept%2C%20cinematic%20photography%20style%2C%20deep%20shadows%20and%20warm%20highlights&width=1920&height=680&seq=mikroihracat-hero-01&orientation=landscape"
            alt="Mikro İhracat"
            loading="eager"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(105deg, rgba(8,10,20,0.92) 0%, rgba(12,18,38,0.80) 55%, rgba(8,10,20,0.50) 100%)' }} />
        </div>

        <div className="absolute inset-0 opacity-20">
          <div className="absolute bottom-20 right-20 w-80 h-80 rounded-full" style={{ background: 'var(--orange)', filter: 'blur(120px)' }} />
        </div>

        <div className="w-full max-w-6xl mx-auto px-6 lg:px-10 relative z-10 pt-36 pb-24">
          <div className="flex items-center gap-2 mb-8">
            <Link to="/hizmetler" className="text-sm hover:opacity-80 transition-opacity" style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>Hizmetler</Link>
            <i className="ri-arrow-right-s-line" style={{ color: 'rgba(255,255,255,0.35)', fontSize: 14 }} />
            <span className="text-sm font-medium" style={{ color: 'var(--orange)' }}>Mikro İhracat – ETGB</span>
          </div>

          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-16">
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(232,97,26,0.18)', border: '1px solid rgba(232,97,26,0.45)' }}>
                <i className="ri-global-line" style={{ color: 'var(--orange)' }} />
                <span className="text-sm font-semibold" style={{ color: 'var(--orange)' }}>Mikro İhracat – ETGB</span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Kolay ve Hızlı<br />
                <span style={{ color: 'var(--orange)' }}>Mikro İhracat</span>
              </h1>

              <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.82)', lineHeight: 1.8, maxWidth: 560 }}>
                300 kg ve 15.000 € fatura değerini aşmayan gönderileriniz, ETGB kapsamında hiçbir prosedür gerektirmeden gümrükleme sistemi ile alıcıya teslim edilir. KDV iadesi avantajından yararlanın.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
                  <i className="ri-mail-send-line" />Teklif Al
                </Link>
                <a href="tel:+908502420822" className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap hover:opacity-80 transition-opacity" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', textDecoration: 'none' }}>
                  <i className="ri-phone-line" />0850 242 0 822
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 grid grid-cols-2 gap-3">
              {[{ val: '300kg', lbl: 'Maks. Ağırlık' }, { val: '15K€', lbl: 'Maks. Değer' }, { val: 'ETGB', lbl: 'Beyanname' }, { val: 'KDV', lbl: 'İadesi' }].map((s, i) => (
                <div key={i} className="text-center px-8 py-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.18)', backdropFilter: 'blur(12px)' }}>
                  <div className="text-2xl font-bold mb-1" style={{ color: 'var(--orange)' }}>{s.val}</div>
                  <div className="text-xs" style={{ color: 'rgba(255,255,255,0.65)' }}>{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ETGB Info */}
      <section className="py-20" style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-14 items-center">
            <div className="flex-shrink-0 w-full lg:w-[420px] h-[280px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=small%20business%20owner%20preparing%20export%20shipment%2C%20filling%20customs%20declaration%20forms%2C%20packages%20ready%20for%20international%20shipping%2C%20organized%20workspace%20with%20documents%2C%20warm%20office%20lighting%2C%20professional%20trade%20documentation%20process&width=420&height=280&seq=mikroihracat-content-01&orientation=landscape"
                alt="Mikro ihracat süreci"
                loading="lazy"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1">
              <h2 className="text-3xl font-bold mb-4" style={{ color: 'var(--text1)' }}>ETGB Nedir?</h2>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                300 kg ve 15.000 € fatura değerini aşmayan gönderileriniz, ETGB (Elektronik Ticaret Gümrük Beyanı) kapsamında hiçbir prosedür gerektirmeden gerçekleştirilen gümrükleme sistemi ile alıcıya teslim edilir.
              </p>
              <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--text3)' }}>
                Mikro ihracat kapsamında firmanız adına ilk defa gönderi yapıyorsanız öncesinde tek sefere mahsus olarak ihracatçılar birliğine kaydolmanız gerekir.
              </p>
              <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text3)' }}>
                Firmanız adına yaptığınız satışların gönderimini ETGB kapsamında yapmanız durumunda KDV iadenizi kolayca alabilirsiniz.
              </p>
              <p className="text-sm font-semibold" style={{ color: 'var(--text2)' }}>
                Destek hattı: <a href="tel:+908502420822" style={{ color: 'var(--orange)' }}>0850 242 0 822</a> – <a href="mailto:cs@cargonet.com.tr" style={{ color: 'var(--orange)' }}>cs@cargonet.com.tr</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-3" style={{ color: 'var(--text1)' }}>Mikro İhracat Avantajları</h2>
            <p className="text-sm" style={{ color: 'var(--text3)' }}>ETGB ile ihracatın kolaylıkları.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div key={i} className="p-6 rounded-2xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-4" style={{ background: 'rgba(232,97,26,0.1)' }}>
                  <i className={`${f.icon} text-xl`} style={{ color: 'var(--orange)' }} />
                </div>
                <h3 className="font-bold text-sm mb-2" style={{ color: 'var(--text1)' }}>{f.title}</h3>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text3)' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20" style={{ background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--text1)' }}>Mikro İhracat İçin Teklif Alın</h2>
          <p className="mb-8 text-sm" style={{ color: 'var(--text3)' }}>Uzman ekibimiz ETGB süreçlerinizi sizin için yönetsin.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/iletisim" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: 'var(--orange)', textDecoration: 'none' }}>
              <i className="ri-mail-send-line" />Teklif Al
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold cursor-pointer whitespace-nowrap" style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--text1)', textDecoration: 'none' }}>
              <i className="ri-arrow-left-line" />Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
